"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectsPage = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const lodash_1 = __importDefault(require("lodash"));
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const ProjectModalComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/ProjectModalComponent");
const ProjectCardSubTitle_1 = require("src/hello_assets/src/components/ui/loggedin/content/projects/components/ProjectCardSubTitle");
const ProjectCardTitle_1 = require("src/hello_assets/src/components/ui/loggedin/content/projects/components/ProjectCardTitle");
require("./projectsPage.less");
const ProjectsPage = ({}) => {
    const isMounted = (0, isMounted_1.default)();
    const [projectProfileViewInModal, setProjectProfileViewInModal] = (0, react_1.useState)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const [createProjectModalVisible, setCreateProjectModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onCreateProjectModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setCreateProjectModalVisible({ visible: false });
        }
    }, [isMounted]);
    const [renameProjectModalVisible, setRenameProjectModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onRenameProjectModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setRenameProjectModalVisible({ visible: false });
            setProjectProfileViewInModal(undefined);
        }
    }, [isMounted]);
    const projectsLoaded = projectsContext.projectsState.loaded;
    const projectsInProgress = projectsContext.projectsState.inProgress;
    const projectsData = projectsContext.projectsState.data;
    const hasProjects = !lodash_1.default.isEmpty(projectsData);
    const onClickCreateProject = () => {
        setCreateProjectModalVisible({ visible: true, nonce: createProjectModalVisible.nonce + 1 });
    };
    const onClickRenameProject = (projectProfileView) => {
        setProjectProfileViewInModal(projectProfileView);
        setRenameProjectModalVisible({ visible: true, nonce: renameProjectModalVisible.nonce + 1 });
    };
    if (projectsLoaded && !hasProjects) {
        return React.createElement(react_router_dom_1.Redirect, { to: AppRouting_1.AppPathGenerator.home() });
    }
    return React.createElement("div", { className: "page_projects" },
        React.createElement(antd_1.PageHeader, { title: "Projects", extra: React.createElement(React.Fragment, null,
                React.createElement(ProjectModalComponent_1.ProjectModalComponent, { key: `createProject${createProjectModalVisible.nonce}`, visible: createProjectModalVisible.visible, onDestroy: onCreateProjectModalDestroy, ctx: "projectsPageHeader" }),
                React.createElement(ProjectModalComponent_1.ProjectModalComponent, { key: `renameProject${renameProjectModalVisible.nonce}`, visible: renameProjectModalVisible.visible, onDestroy: onRenameProjectModalDestroy, projectView: projectProfileViewInModal, ctx: "projectsPageRename" }),
                React.createElement(antd_1.Space, null,
                    React.createElement(antd_1.Button, { onClick: onClickCreateProject, icon: React.createElement(icons_1.PlusOutlined, null), loading: projectsInProgress, disabled: projectsInProgress },
                        React.createElement("span", null, "Create new project")),
                    React.createElement(antd_1.Button, { icon: React.createElement(icons_1.ReloadOutlined, null), onClick: projectsContext.fetchAllProjects, disabled: projectsInProgress }))) }),
        React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(antd_1.List, { grid: { gutter: 16, column: 1, }, loading: projectsInProgress, dataSource: projectsContext.projectsState.data, renderItem: ({ view: projectProfileView }, projectIndex) => {
                        const { projectApiKey, projectName } = projectProfileView;
                        const currentProjectData = projectsContext.getProjectData(projectApiKey);
                        const integrationCompleted = currentProjectData.state.hasData;
                        const projectIntegrationClassName = integrationCompleted ? "projectIntegrationCompleted" : "projectIntegrationIncomplete";
                        const projectCreationDateTime = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(projectProfileView.createdTimeSec * 1000).format(DateTimeFacade_1.DateTimeFormats.MonthDayYearTime);
                        const menu = React.createElement(antd_1.Menu, null,
                            React.createElement(antd_1.Menu.Item, { key: "rename", onClick: () => onClickRenameProject(projectProfileView) }, "Rename"));
                        const dropdown = React.createElement(antd_1.Dropdown, { overlay: menu, trigger: ["click"], placement: "bottomRight" },
                            React.createElement(antd_1.Button, { type: "link", icon: React.createElement(icons_1.MoreOutlined, { style: { fontSize: "20px" } }) }));
                        const projectCardSubTitle = React.createElement(ProjectCardSubTitle_1.ProjectCardSubTitle, { projectApiKey: projectApiKey });
                        const projectCardTitle = React.createElement(ProjectCardTitle_1.ProjectCardTitle, { projectApiKey: projectApiKey, projectName: projectName });
                        return React.createElement(antd_1.List.Item, { key: projectApiKey, className: `projectRow ${projectIntegrationClassName}` },
                            React.createElement(antd_1.PageHeader, { title: projectCardTitle, subTitle: projectCardSubTitle, className: "ant-card-bordered", extra: dropdown },
                                React.createElement(antd_1.Typography.Paragraph, null,
                                    "Api Key: ",
                                    React.createElement(antd_1.Typography.Text, { copyable: true, className: "apiKey" }, projectApiKey)),
                                React.createElement(antd_1.Typography.Paragraph, null,
                                    "Created: ",
                                    projectCreationDateTime),
                                React.createElement(antd_1.Typography.Paragraph, null,
                                    "Please find the integration instructions ",
                                    React.createElement("a", { href: AppRouting_1.AppPathGenerator.github.home(), target: "_blank" }, "here"))));
                    } }))));
};
exports.ProjectsPage = ProjectsPage;
